export default "__VITE_ASSET__CAVWD4R7__"